class AstroCollectionShowcase {
  constructor(section) {
    this.section = section;
    this.tabs = Array.from(
      section.querySelectorAll('[data-showcase-tab]')
    );
    this.panels = Array.from(
      section.querySelectorAll('[data-showcase-panel]')
    );
    this.desktopImages = Array.from(
      section.querySelectorAll('[data-showcase-desktop-image]')
    );
    this.mobileImages = Array.from(
      section.querySelectorAll('[data-showcase-mobile-image]')
    );

    this.activeIndex = 0;

    if (!this.tabs.length) return;

    this.bindEvents();
  }

  bindEvents() {
    this.tabs.forEach((tab, index) => {
      tab.addEventListener('click', () => {
        this.activate(index, true);
      });

      tab.addEventListener('keydown', (event) => {
        let nextIndex = null;

        if (event.key === 'ArrowDown' || event.key === 'ArrowRight') {
          nextIndex = (index + 1) % this.tabs.length;
        }

        if (event.key === 'ArrowUp' || event.key === 'ArrowLeft') {
          nextIndex =
            (index - 1 + this.tabs.length) % this.tabs.length;
        }

        if (event.key === 'Home') {
          nextIndex = 0;
        }

        if (event.key === 'End') {
          nextIndex = this.tabs.length - 1;
        }

        if (nextIndex === null) return;

        event.preventDefault();
        this.activate(nextIndex, true);
        this.tabs[nextIndex].focus();
      });
    });
  }

  activate(index, updateFocus = false) {
    if (index < 0 || index >= this.tabs.length) return;

    this.activeIndex = index;

    this.tabs.forEach((tab, tabIndex) => {
      const active = tabIndex === index;

      tab.classList.toggle('is-active', active);
      tab.setAttribute(
        'aria-selected',
        active ? 'true' : 'false'
      );
      tab.setAttribute('tabindex', active ? '0' : '-1');
    });

    this.panels.forEach((panel, panelIndex) => {
      const active = panelIndex === index;

      panel.hidden = !active;
      panel.classList.toggle('is-active', active);
    });

    this.desktopImages.forEach((image, imageIndex) => {
      const active = imageIndex === index;

      image.hidden = !active;
      image.classList.toggle('is-active', active);
    });

    this.mobileImages.forEach((image, imageIndex) => {
      const active = imageIndex === index;

      image.hidden = !active;
      image.classList.toggle('is-active', active);
    });

    if (updateFocus) {
      this.tabs[index].focus({
        preventScroll: true
      });
    }
  }
}

const initializeAstroCollectionShowcases = (root = document) => {
  root
    .querySelectorAll('[data-collection-showcase]')
    .forEach((section) => {
      if (section.dataset.showcaseInitialized === 'true') {
        return;
      }

      section.dataset.showcaseInitialized = 'true';
      section.collectionShowcase =
        new AstroCollectionShowcase(section);
    });
};

document.addEventListener('DOMContentLoaded', () => {
  initializeAstroCollectionShowcases();
});

document.addEventListener('shopify:section:load', (event) => {
  initializeAstroCollectionShowcases(event.target);
});